/* =========================================================================
   Alama Studio — Trade Program landing page
   Vanilla JS: sticky header, mobile nav, FAQ accordion, form, analytics.
   No dependencies, no build step.
   ========================================================================= */
(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     Analytics — guarded stubs. Each call no-ops if the provider is absent.
     Events: trade_apply_click, library_download_click, trade_form_submit,
             scroll-depth milestones.
     ----------------------------------------------------------------------- */
  function track(eventName, params) {
    params = params || {};
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
      // NB: l'evento Meta "Lead" NON si invia qui: scatta sulla thank you page
      // (piu' affidabile del submit, che redirige subito, ed evita il doppio conteggio).
    } catch (e) { /* analytics must never break the page */ }
    // Helpful during development:
  }

  /* -----------------------------------------------------------------------
     CTA click tracking (data-cta on any element)
     ----------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cta]');
    if (!el) return;
    var cta = el.getAttribute('data-cta');
    if (cta === 'info') track('info_request_click', { location: locationOf(el) });
    if (cta === 'library') track('library_download_click', { location: locationOf(el) });
  });
  function locationOf(el) {
    if (el.closest('.site-header')) return 'header';
    if (el.closest('.hero')) return 'hero';
    if (el.closest('.site-footer')) return 'footer';
    if (el.closest('#contact')) return 'final';
    if (el.closest('.mobile-nav')) return 'mobile-nav';
    return 'page';
  }

  /* -----------------------------------------------------------------------
     Sticky header — solid background after scrolling past the hero top
     ----------------------------------------------------------------------- */
  var header = document.getElementById('site-header');
  function onScrollHeader() {
    if (window.scrollY > 40) header.classList.add('is-stuck');
    else header.classList.remove('is-stuck');
  }
  onScrollHeader();
  window.addEventListener('scroll', onScrollHeader, { passive: true });

  /* -----------------------------------------------------------------------
     Mobile nav
     ----------------------------------------------------------------------- */
  var toggle = document.getElementById('nav-toggle');
  var drawer = document.getElementById('mobile-nav');
  function setMenu(open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  toggle.addEventListener('click', function () {
    setMenu(!drawer.classList.contains('is-open'));
  });
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('a')) setMenu(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false);
  });

  /* -----------------------------------------------------------------------
     FAQ accordion — keyboard accessible, animated height
     ----------------------------------------------------------------------- */
  var qs = Array.prototype.slice.call(document.querySelectorAll('.faq-q'));
  function setPanel(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      panel.style.height = panel.scrollHeight + 'px';
      // settle to auto after transition so it reflows on resize
      panel.addEventListener('transitionend', function te() {
        if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        panel.removeEventListener('transitionend', te);
      });
    } else {
      // from auto -> fixed -> 0 so the transition runs
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
    }
  }
  qs.forEach(function (btn) {
    // initialise from markup (one open by default)
    var open = btn.getAttribute('aria-expanded') === 'true';
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    panel.style.height = open ? 'auto' : '0px';

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      setPanel(btn, !isOpen);
    });
  });
  window.addEventListener('resize', function () {
    qs.forEach(function (btn) {
      if (btn.getAttribute('aria-expanded') === 'true') {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        panel.style.height = 'auto';
      }
    });
  });

  /* -----------------------------------------------------------------------
     Lead form — validation + loading / success / error states
     ----------------------------------------------------------------------- */
  var form = document.getElementById('lead-form');
  if (form) {
  var submitBtn = document.getElementById('submit-btn');
  var errorMsg = document.getElementById('form-error');
  var successEl = document.getElementById('form-success');
  var btnLabel = submitBtn.querySelector('.btn-label');
  var SUBMIT_LABEL = btnLabel.textContent;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function rowOf(field) { return field.closest('.form-row, .form-row--split > div') || field.closest('.form-row'); }

  // Telefono: opzionale, ma se compilato deve essere un numero plausibile
  // (il CRM lo valida e rifiuterebbe il lead). Volutamente permissiva sui formati internazionali.
  function phoneOk(v) {
    v = (v || '').trim();
    if (v === '') return true;                       // vuoto = ok, il campo e' opzionale
    if (/[A-Za-z]/.test(v)) return false;            // niente lettere
    return (v.match(/\d/g) || []).length >= 6;       // almeno 6 cifre
  }

  function validateField(field) {
    var wrap = field.closest('.form-row--split') ? field.parentElement : field.closest('.form-row');
    var valid = true;
    if (field.type === 'tel') valid = phoneOk(field.value);
    else if (field.hasAttribute('required')) {
      if (field.type === 'email') valid = EMAIL_RE.test(field.value.trim());
      else valid = field.value.trim() !== '';
    }
    wrap.classList.toggle('invalid', !valid); field.setAttribute('aria-invalid', String(!valid));
    return valid;
  }

  function validateForm() {
    var fields = form.querySelectorAll('input[required], select[required], input[type="tel"]');
    var ok = true, firstInvalid = null;
    Array.prototype.forEach.call(fields, function (f) {
      var v = validateField(f);
      if (!v && !firstInvalid) firstInvalid = f;
      ok = ok && v;
    });
    if (firstInvalid) firstInvalid.focus();
    return ok;
  }

  // live-clear errors as the user fixes them
  form.addEventListener('input', function (e) {
    var f = e.target;
    if (f.matches('input[required], select[required], input[type="tel"]')) {
      var wrap = f.closest('.form-row--split') ? f.parentElement : f.closest('.form-row');
      if (wrap.classList.contains('invalid')) validateField(f);
    }
  });

  /* Invio lead: POST al ponte (Cloudflare Worker) che firma e inoltra al CRM Opacmare. */
  var BRIDGE_URL = 'https://alama-crm-bridge.weareuncommon.workers.dev';
  function submitTradeLead(payload) {
    return fetch(BRIDGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error('bridge ' + r.status); return r.json(); })
      .then(function (d) { if (!d || !d.ok) throw new Error('crm'); return d; });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorMsg.classList.remove('is-visible');
    if (!validateForm()) return;

    var payload = {
      fullName: form.fullName.value.trim(),
      studio: form.studio.value.trim(),
      email: form.email.value.trim(),
      phone: form.phone.value.trim() || null,
      role: form.role.value,
      country: form.country.value.trim(),
      projectType: form.projectType.value || null,
      message: form.message.value.trim() || null,
      page: '/for-interior-designers',
      formType: 'info-request',
      submittedAt: new Date().toISOString(),
      _hp: form._hp ? form._hp.value : ''
    };

    // loading state
    submitBtn.classList.add('is-loading');
    submitBtn.setAttribute('aria-busy', 'true');
    btnLabel.textContent = 'Sending…';

    submitTradeLead(payload).then(function () {
      track('info_form_submit', { role: payload.role, country: payload.country, projectType: payload.projectType });
      window.location.assign('/pages/thank-you');
    }).catch(function () {
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('aria-busy');
      btnLabel.textContent = SUBMIT_LABEL;
      errorMsg.classList.add('is-visible');
    });
  });
  } /* end lead-form guard (assente sulla thank-you page) */

  /* -----------------------------------------------------------------------
     Reveal-on-scroll
     ----------------------------------------------------------------------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* -----------------------------------------------------------------------
     Scroll-depth milestones (25 / 50 / 75 / 100)
     ----------------------------------------------------------------------- */
  var milestones = [25, 50, 75, 100], fired = {};
  function onScrollDepth() {
    var doc = document.documentElement;
    var scrolled = (window.scrollY + window.innerHeight);
    var pct = Math.min(100, Math.round((scrolled / doc.scrollHeight) * 100));
    milestones.forEach(function (m) {
      if (pct >= m && !fired[m]) { fired[m] = true; track('scroll_depth', { percent: m }); }
    });
  }
  window.addEventListener('scroll', onScrollDepth, { passive: true });
})();
